/**
 * Dữ liệu chương trình tặng quà ngày Quốc tế Phụ nữ 8/3
 */

export const WOMEN_8T3_MENUS = [
  {
    menu: 'Bánh 8/3',
    concept: 'Thiên nga',
    desc: 'Bánh kem thiên nga hồng - Pink Ombre Swan | Size nhỏ',
    sku: 'V9453',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa tulip giấy hồng (hộp mica) | Size mini',
    sku: 'V9169',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa tulip giấy hồng (hộp mica) | Size nhỏ',
    sku: 'V9173',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa tulip giấy hồng (hộp mica) | Size vừa',
    sku: 'V9171',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa Tulip hồng vải voan (hộp mica) | Size mini',
    sku: 'V9181',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa Tulip hồng vải voan (hộp mica) | Size nhỏ',
    sku: 'V9183',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa Tulip hồng vải voan (hộp mica) | Size vừa',
    sku: 'V9185',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem Bouquet Flowers (hộp mica) | Size mini',
    sku: 'V10332',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem Bouquet Flowers (hộp mica) | Size nhỏ',
    sku: 'V10333',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem Bouquet Flowers (hộp mica) | Size vừa',
    sku: 'V10334',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa dâu tây đèn nháy (hộp mica) | Size mini',
    sku: 'V9187',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa dâu tây đèn nháy (hộp mica) | Size nhỏ',
    sku: 'V9189',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bó hoa',
    desc: 'Bánh kem bó hoa dâu tây đèn nháy (hộp mica) | Size vừa',
    sku: 'V9191',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh tim',
    desc: 'Bánh kem nến xoắn tim nơ hồng | Size mini',
    sku: 'V10697',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh tim',
    desc: 'Bánh kem nến xoắn tim nơ hồng | Size nhỏ',
    sku: 'V10698',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh tim',
    desc: 'Bánh kem nến xoắn tim nơ hồng | Size vừa',
    sku: 'V10699',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh tim',
    desc: 'Bánh kem tua rua nến xoắn tim hồng | Size mini',
    sku: 'V10703',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh tim',
    desc: 'Bánh kem tua rua nến xoắn tim hồng | Size nhỏ',
    sku: 'V10704',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh tim',
    desc: 'Bánh kem tua rua nến xoắn tim hồng | Size vừa',
    sku: 'V10705',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Socola',
    desc: 'Hộp truffle 9 viên kèm túi & thiệp màu loang | Size mini',
    sku: 'V2204',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Socola',
    desc: 'Hộp truffle 12 viên kèm túi & thiệp màu loang | Size mini',
    sku: 'V2205',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Socola',
    desc: 'Hộp truffle 9 viên kèm túi & thiệp màu đỏ | Size mini',
    sku: 'V10687',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Socola',
    desc: 'Hộp truffle 12 viên kèm túi & thiệp màu đỏ | Size mini',
    sku: 'V10686',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Socola',
    desc: 'Hộp Dark Nama Chocolate 9 viên kèm túi & thiệp (hộp đỏ) | Size mini',
    sku: 'V10688',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Socola',
    desc: 'Hộp Matcha Nama Chocolate 9 viên kèm túi & thiệp (hộp xanh cốm) | Size mini',
    sku: 'V10689',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Singapore bó hoa | Size mini',
    sku: 'V8840',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Singapore bó hoa | Size nhỏ',
    sku: 'V8842',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Singapore bó hoa | Size vừa',
    sku: 'V8844',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Hộp 12 bánh su kem Singapore trang trí hoa quả tươi | Size mini',
    sku: 'V8993',
    giftName: 'sparkle',
    sparkleNeed: 5,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Bouquet Flowers | Size mini',
    sku: 'V10335',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Bouquet Flowers | Size nhỏ',
    sku: 'V10336',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Bouquet Flowers | Size vừa',
    sku: 'V10337',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Singapore tròn | Size mini',
    sku: 'V8832',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Singapore tròn | Size nhỏ',
    sku: 'V8836',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Singapore tròn | Size vừa',
    sku: 'V8834',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Bánh su kem Singapore tròn 60 bánh | Size to',
    sku: 'V10338',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Su kem',
    desc: 'Set bánh su kem Singapore hoa quả chữ nhật (48 bánh) | Chữ Nhật',
    sku: 'V8838',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake tulip | Size mini',
    sku: 'V9446',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake tulip | Size nhỏ',
    sku: 'V9447',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake tulip | Size vừa',
    sku: 'V9448',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake tulip | Chữ Nhật',
    sku: 'V9449',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake chà bông trứng muối | Size mini',
    sku: 'V9280',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake chà bông trứng muối | Size nhỏ',
    sku: 'V9281',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake chà bông trứng muối | Size vừa',
    sku: 'V9282',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake chà bông trứng muối | Chữ Nhật',
    sku: 'V9283',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake hoa quả | Size mini',
    sku: 'V9284',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake hoa quả | Size nhỏ',
    sku: 'V9285',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake hoa quả | Size vừa',
    sku: 'V9286',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Cupcake',
    desc: 'Set bánh cupcake hoa quả | Chữ Nhật',
    sku: 'V9287',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Hộp 20 bánh tart hoa quả tươi | Size mini',
    sku: 'V10594',
    giftName: 'sparkle',
    sparkleNeed: 5,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tươi | Size mini',
    sku: 'V10570',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tươi | Size nhỏ',
    sku: 'V10572',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tươi | Size vừa',
    sku: 'V10574',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tươi | Size to',
    sku: 'V10576',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart  hoa quả trái tim | Size mini',
    sku: 'V10586',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart  hoa quả trái tim | Size nhỏ',
    sku: 'V10588',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart  hoa quả trái tim | Size vừa',
    sku: 'V10590',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tròn | Size mini',
    sku: 'V10578',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tròn | Size nhỏ',
    sku: 'V10580',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tròn | Size vừa',
    sku: 'V10582',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set tart hoa quả tròn | Size to',
    sku: 'V10584',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Tart',
    desc: 'Set 63 bánh tart hoa quả tươi (chữ nhật) | Chữ Nhật',
    sku: 'V10592',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Chữ nhật',
    desc: 'Bánh kem chữ nhật cắt miếng viết chữ | Chữ Nhật',
    sku: 'V2603',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Chữ nhật',
    desc: 'Bông lan trứng muối chữ nhật cắt miếng viết chữ 24x32x6cm | Chữ Nhật',
    sku: 'V9482',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set bánh Sweet Sunshine (bông lan trứng muối - bánh kem bắp - mousse xoài) | Size mini',
    sku: 'V9041',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set bánh Sweet Sunshine (bông lan trứng muối - bánh kem bắp - mousse xoài) | Size nhỏ',
    sku: 'V9043',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set bánh Sweet Sunshine (bông lan trứng muối - bánh kem bắp - mousse xoài) | Size vừa',
    sku: 'V9045',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set bánh Sweet Sunshine (bông lan trứng muối - bánh kem bắp - mousse xoài) | Size to',
    sku: 'V10306',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set bánh Sweet Sunshine (bông lan trứng muối - bánh kem bắp - mousse xoài) | Size to HN only',
    sku: 'V10307',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set Classic Tiramisu | Size mini',
    sku: 'V9065',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set Classic Tiramisu | Size nhỏ',
    sku: 'V9067',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set Classic Tiramisu | Size vừa',
    sku: 'V9069',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set Classic Tiramisu | Size to',
    sku: 'V10308',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set Classic Tiramisu | Size to HN only',
    sku: 'V10309',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 0
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set mousse trang trí hoa quả tươi  | Size mini',
    sku: 'V8321',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set mousse trang trí hoa quả tươi  | Size nhỏ',
    sku: 'V8323',
    giftName: 'sparkle',
    sparkleNeed: 2,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set mousse trang trí hoa quả tươi  | Size vừa',
    sku: 'V8327',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set mousse trang trí hoa quả tươi  | Size to',
    sku: 'V10304',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Bánh cốc',
    desc: 'Set mousse trang trí hoa quả tươi  | Size to HN only',
    sku: 'V10305',
    giftName: 'sparkle',
    sparkleNeed: 1,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Set quà DN',
    desc: 'Set 4 bánh mousse trang trí hoa quả | Size mini',
    sku: 'V10729',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Set quà DN',
    desc: 'Set quà bánh kem tulip + trà vải hoa hồng | Size mini',
    sku: 'V10730',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh 8/3',
    concept: 'Set quà DN',
    desc: 'Set quà bông lan trứng muối + trà đào | Size mini',
    sku: 'V10176',
    giftName: 'card',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem bơ xoài việt quất | Size mini',
    sku: 'V2879',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem bơ xoài việt quất | Size nhỏ',
    sku: 'V2881',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem bơ xoài việt quất | Size vừa',
    sku: 'V2883',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem bơ xoài việt quất | Size to',
    sku: 'V10181',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh sữa chua hoa quả | Size mini',
    sku: 'V1506',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh sữa chua hoa quả | Size nhỏ',
    sku: 'V1507',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh sữa chua hoa quả | Size vừa',
    sku: 'V1531',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh sữa chua hoa quả | Size to',
    sku: 'V10188',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh red velvet sữa chua việt quất | Size mini',
    sku: 'V2709',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh red velvet sữa chua việt quất | Size nhỏ',
    sku: 'V2711',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh red velvet sữa chua việt quất | Size vừa',
    sku: 'V2713',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh red velvet sữa chua việt quất | Size to',
    sku: 'V10189',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem giỏ hoa xoài dừa | Size mini',
    sku: 'V10001',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem giỏ hoa xoài dừa | Size nhỏ',
    sku: 'V10002',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem giỏ hoa xoài dừa | Size vừa',
    sku: 'V10003',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem giỏ hoa xoài dừa | Size to',
    sku: 'V10182',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Xoài Dừa | Size mini',
    sku: 'V1397',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Xoài Dừa | Size nhỏ',
    sku: 'V1398',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Xoài Dừa | Size vừa',
    sku: 'V1462',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Xoài Dừa | Size to',
    sku: 'V10217',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Triple Choco | Size mini',
    sku: 'V1393',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Triple Choco | Size nhỏ',
    sku: 'V1394',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Triple Choco | Size vừa',
    sku: 'V1460',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem Triple Choco | Size to',
    sku: 'V10187',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem red velvet tròn dâu Đà Lạt | Size mini',
    sku: 'V1596',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem red velvet tròn dâu Đà Lạt | Size nhỏ',
    sku: 'V1597',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem red velvet tròn dâu Đà Lạt | Size vừa',
    sku: 'V1598',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh kem red velvet tròn dâu Đà Lạt | Size to',
    sku: 'V10218',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối việt quất | Size mini',
    sku: 'V2449',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối việt quất | Size nhỏ',
    sku: 'V2450',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối việt quất | Size vừa',
    sku: 'V2451',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối việt quất | Size to',
    sku: 'V10229',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối sốt phô mai | Size mini',
    sku: 'V2665',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối sốt phô mai | Size nhỏ',
    sku: 'V2666',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối sốt phô mai | Size vừa',
    sku: 'V2667',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối sốt phô mai | Size to',
    sku: 'V10183',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bông lan trứng muối couple bear | Size mini',
    sku: 'V9556',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bông lan trứng muối couple bear | Size nhỏ',
    sku: 'V9557',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bông lan trứng muối couple bear | Size vừa',
    sku: 'V9558',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bông lan trứng muối couple bear | Size to',
    sku: 'V10186',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối xoài | Size mini',
    sku: 'V2662',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối xoài | Size nhỏ',
    sku: 'V2663',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối xoài | Size vừa',
    sku: 'V2664',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Bánh kem',
    desc: 'Bánh bông lan trứng muối xoài | Size to',
    sku: 'V10180',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse sữa chua việt quất | Size mini',
    sku: 'V2414',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse sữa chua việt quất | Size nhỏ',
    sku: 'V2415',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse sữa chua việt quất | Size vừa',
    sku: 'V2416',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse chanh leo | Size mini',
    sku: 'V1401',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse chanh leo | Size nhỏ',
    sku: 'V1402',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse chanh leo | Size vừa',
    sku: 'V1741',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse xoài | Size mini',
    sku: 'V1849',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse xoài | Size nhỏ',
    sku: 'V1864',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse xoài | Size vừa',
    sku: 'V1879',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse việt quất socola | Size mini',
    sku: 'V2583',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse việt quất socola | Size nhỏ',
    sku: 'V2584',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Mousse',
    desc: 'Mousse việt quất socola | Size vừa',
    sku: 'V2585',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 0
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Oolong Longan Cake hộp thiếc 670g | Hộp thiếc tròn',
    sku: 'V9653',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Choco Dream Cake hộp thiếc 435g | Hộp thiếc tròn',
    sku: 'V9630',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Mãng cầu xiêm phô mai hộp thiếc mini 320g | Hộp thiếc tròn',
    sku: 'V10159',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Oolong Lemon Cheese Cake hộp thiếc mini 320g | Hộp thiếc tròn',
    sku: 'V10468',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Oolong Lemon Cheese Cake hộp thiếc 570g | Hộp thiếc tròn',
    sku: 'V10462',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Mãng cầu xiêm phô mai hộp thiếc 670g | Hộp thiếc tròn',
    sku: 'V10116',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Oolong Longan Cake hộp thiếc mini 330g | Hộp thiếc tròn',
    sku: 'V9968',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Hộp thiếc Tiramisu tim classic | Hộp thiếc dài',
    sku: 'V10717',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Hộp thiếc Tiramisu tim matcha | Hộp thiếc dài',
    sku: 'V10720',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Choco Tiramisu mini | Hộp thiếc tròn',
    sku: 'V10596',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  },
  {
    menu: 'Bánh sinh nhật',
    concept: 'Hộp thiếc',
    desc: 'Choco Matchamisu mini | Hộp thiếc tròn',
    sku: 'V10598',
    giftName: 'no-gift',
    sparkleNeed: 0,
    HCM: 1
  }
]
